import { ComponentType, lazy } from 'react';
import { logger } from '@/utils/logger';
import { RECOVERY_STATE_VERSION, RECOVERY_STORAGE_KEY, decideRecovery, parseRecoveryState } from './lazyImportRecovery';

// Ignoring this util functions as props can varied wildly
// oxlint-disable-next-line no-explicit-any
const lazyWithReload = (factory: () => Promise<{ default: ComponentType<any> }>) => {
  return lazy(() => factory().catch(importErrorHandler));
};

// Ignoring this util functions as props can varied wildly
// oxlint-disable-next-line no-explicit-any
function importErrorHandler(err: Error): { default: ComponentType<any> } {
  const now = Date.now();
  const online = navigator.onLine;
  const route = window.location.pathname;
  const release = globalThis.__APP_RELEASE__ ?? '';
  const stored = parseRecoveryState(sessionStorage.getItem(RECOVERY_STORAGE_KEY));
  const action = decideRecovery({ now, online, stored, error: err });

  const base = { category: action.category, route, release };

  if (action.type === 'reload') {
    sessionStorage.setItem(
      RECOVERY_STORAGE_KEY,
      JSON.stringify({ v: RECOVERY_STATE_VERSION, attemptedAt: now, ...base })
    );
    logger.info('lazy_import.recovered', { ...base, online });
    window.location.reload();
    return { default: () => null };
  }

  // Recovery exhausted or not applicable. Sentry global handlers are disabled,
  // so logger.error is the only telemetry path — always log before rethrowing.
  logger.error(`lazy_import.${action.category}`, err, {
    ...base,
    online,
    attemptedAt: stored?.attemptedAt ?? null,
    previousRecoveryCategory: stored?.category ?? null,
    previousRecoveryRoute: stored?.route ?? null,
    now,
    errorName: err.name,
    errorMessage: err.message,
  });
  throw err;
}

export { lazyWithReload };
